import { Grid, Image, Text } from '@pega/cosmos-react-core';
import React from 'react';
import { useNavigate } from 'react-router-dom';
import * as Logos from '../../constants/images';
import useLocalTranslation from '../../hooks/useLocalTranslation';
import AddConnectionCard from '../SocialMedia/Home/AddConnectionCard';
import SectionRenderTemplate from '../Utilities/SectionRenderTemplate';

export interface AddConfigureProps {
  hideNavigation?: boolean;
}

const AddConfigure: React.FC<AddConfigureProps> = ({ hideNavigation }) => {
  const navigate = useNavigate();
  const translate = useLocalTranslation();

  const onLanguageServiceClick = () => {
    navigate('/language-service-create');
  };

  const languageService = {
    image: <Image src={Logos.GoogleTranslateLogo} alt="Language Service" />,
    title: `${translate('language_service')}`,
    description: '',
  };

  const headerAddNewElement = () => {
    return (
      <Text variant="h1" as="h1">
        {translate('add_global_config')}
      </Text>
    );
  };

  return (
    <SectionRenderTemplate hideNavigation={hideNavigation} header={headerAddNewElement()}>
      <Grid
        container={{
          cols: 'repeat(4, 1fr)',
          gap: 2,
        }}
      >
        <AddConnectionCard onClick={onLanguageServiceClick}>{languageService}</AddConnectionCard>
      </Grid>
    </SectionRenderTemplate>
  );
};

export default AddConfigure;
